import { render, staticRenderFns } from "./Microcart.vue?vue&type=template&id=b89f54fc&"
import script from "./Microcart.vue?vue&type=script&lang=js&"
export * from "./Microcart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports